export default "__VITE_ASSET__CdtRGRrB__"